import { render, staticRenderFns } from "./CertificateRequest.vue?vue&type=template&id=d24e45e2&scoped=true"
import script from "./CertificateRequest.vue?vue&type=script&lang=js"
export * from "./CertificateRequest.vue?vue&type=script&lang=js"
import style0 from "./CertificateRequest.vue?vue&type=style&index=0&id=d24e45e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24e45e2",
  null
  
)

export default component.exports